// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../web/myagent/app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../web/myagent/app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Geist:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * MyAgent UI - Ethereal Tech Design System
 *
 * A distinctive design language that blends ethereal aesthetics with modern tech.
 * Features: Glassmorphism, gradient backgrounds, ambient glow effects,
 * refined typography with Geist font family.
 */

/* Import Geist font family */

:root {
  /* ===== Color Palette - Ethereal Spectrum ===== */

  /* Primary Gradient - Deep indigo to violet */
  --color-primary: #6366f1;
  --color-primary-hover: #818cf8;
  --color-primary-glow: rgba(99, 102, 241, 0.4);
  --color-primary-dim: rgba(99, 102, 241, 0.15);

  /* Accent - Ethereal cyan */
  --color-accent: #22d3ee;
  --color-accent-hover: #67e8f9;
  --color-accent-glow: rgba(34, 211, 238, 0.3);

  /* Secondary - Soft violet */
  --color-secondary: #a78bfa;
  --color-secondary-hover: #c4b5fd;

  /* Background - Deep space gradient base colors */
  --bg-base: #0a0a0f;
  --bg-primary: #0d0d14;
  --bg-secondary: rgba(20, 20, 30, 0.8);
  --bg-tertiary: rgba(30, 30, 45, 0.6);
  --bg-elevated: rgba(25, 25, 40, 0.9);
  --bg-hover: rgba(40, 40, 60, 0.5);

  /* Glass effect backgrounds */
  --glass-bg: rgba(255, 255, 255, 0.03);
  --glass-border: rgba(255, 255, 255, 0.08);
  --glass-highlight: rgba(255, 255, 255, 0.1);

  /* Text Colors - Ethereal hierarchy */
  --text-primary: #f0f0f5;
  --text-secondary: #a0a0b5;
  --text-tertiary: #6b6b80;
  --text-placeholder: #4a4a5e;
  --text-dim: #3a3a4e;
  --text-glow: rgba(240, 240, 245, 0.8);

  /* Message-specific colors */
  --message-user-bg: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(139, 92, 246, 0.15));
  --message-user-border: rgba(99, 102, 241, 0.3);
  --message-user-text: var(--text-primary);
  --message-assistant-bg: transparent;
  --message-assistant-text: var(--text-primary);

  /* Input colors */
  --input-bg: rgba(20, 20, 30, 0.6);
  --input-border: rgba(255, 255, 255, 0.06);
  --input-focus-border: rgba(99, 102, 241, 0.5);
  --input-focus-glow: 0 0 20px rgba(99, 102, 241, 0.15);

  /* Status Colors - Luminous variants */
  --color-success: #34d399;
  --color-success-glow: rgba(52, 211, 153, 0.3);
  --color-warning: #fbbf24;
  --color-warning-glow: rgba(251, 191, 36, 0.3);
  --color-error: #f87171;
  --color-error-glow: rgba(248, 113, 113, 0.3);
  --color-info: #60a5fa;
  --color-info-glow: rgba(96, 165, 250, 0.3);

  /* ===== Spacing - Generous and airy ===== */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 16px;
  --spacing-lg: 24px;
  --spacing-xl: 32px;
  --spacing-2xl: 48px;
  --spacing-3xl: 64px;

  /* ===== Border Radius - Soft and organic ===== */
  --radius-xs: 4px;
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --radius-xl: 24px;
  --radius-2xl: 32px;
  --radius-full: 9999px;

  /* ===== Typography - Geist Family ===== */
  --font-family: 'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
  --font-family-mono: 'Geist Mono', 'SF Mono', 'Fira Code', 'JetBrains Mono', monospace;

  /* Font sizes - Refined scale */
  --font-size-xs: 11px;
  --font-size-sm: 13px;
  --font-size-base: 15px;
  --font-size-lg: 17px;
  --font-size-xl: 20px;
  --font-size-2xl: 26px;
  --font-size-3xl: 34px;
  --font-size-4xl: 48px;

  /* Font weights */
  --font-weight-light: 300;
  --font-weight-normal: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;

  /* Line heights */
  --line-height-tight: 1.3;
  --line-height-normal: 1.6;
  --line-height-relaxed: 1.8;

  /* Letter spacing */
  --letter-spacing-tight: -0.02em;
  --letter-spacing-normal: 0;
  --letter-spacing-wide: 0.05em;
  --letter-spacing-wider: 0.1em;

  /* ===== Shadows - Ethereal depth ===== */
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.15);
  --shadow-md: 0 8px 24px rgba(0, 0, 0, 0.2);
  --shadow-lg: 0 16px 48px rgba(0, 0, 0, 0.25);
  --shadow-xl: 0 24px 64px rgba(0, 0, 0, 0.3);
  --shadow-glow-primary: 0 0 40px var(--color-primary-glow);
  --shadow-glow-accent: 0 0 40px var(--color-accent-glow);
  --shadow-inner: inset 0 1px 0 rgba(255, 255, 255, 0.05);

  /* ===== Z-Index Scale ===== */
  --z-base: 0;
  --z-dropdown: 100;
  --z-header: 200;
  --z-overlay: 900;
  --z-modal: 1000;
  --z-tooltip: 1100;
  --z-notification: 1200;

  /* ===== Transitions - Smooth and natural ===== */
  --ease-out-expo: cubic-bezier(0.16, 1, 0.3, 1);
  --ease-out-quart: cubic-bezier(0.25, 1, 0.5, 1);
  --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
  --ease-spring: cubic-bezier(0.34, 1.56, 0.64, 1);

  --transition-fast: 150ms var(--ease-out-quart);
  --transition-base: 250ms var(--ease-out-expo);
  --transition-slow: 400ms var(--ease-out-expo);
  --transition-spring: 500ms var(--ease-spring);

  /* ===== Blur values ===== */
  --blur-sm: 8px;
  --blur-md: 16px;
  --blur-lg: 32px;
  --blur-xl: 64px;

  /* ===== Breakpoints ===== */
  --breakpoint-sm: 640px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 1024px;
  --breakpoint-xl: 1280px;
}

/* ===== Theme: Dark (Default) ===== */
[data-theme="dark"] {
  --bg-primary: #0d0d14;
  --bg-secondary: rgba(20, 20, 30, 0.8);
  --bg-tertiary: rgba(30, 30, 45, 0.6);
  --bg-elevated: rgba(25, 25, 40, 0.9);

  --text-primary: #f0f0f5;
  --text-secondary: #a0a0b5;
  --text-tertiary: #6b6b80;

  --message-user-bg: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(139, 92, 246, 0.15));
  --message-user-border: rgba(99, 102, 241, 0.3);
  --message-assistant-bg: transparent;

  --input-bg: rgba(20, 20, 30, 0.6);
  --input-border: rgba(255, 255, 255, 0.06);
}

/* ===== Theme: Light ===== */
[data-theme="light"] {
  --bg-base: #f8f9fc;
  --bg-primary: #ffffff;
  --bg-secondary: rgba(248, 249, 252, 0.95);
  --bg-tertiary: rgba(240, 241, 246, 0.9);
  --bg-elevated: rgba(255, 255, 255, 0.98);
  --bg-hover: rgba(240, 241, 246, 0.8);

  --glass-bg: rgba(255, 255, 255, 0.7);
  --glass-border: rgba(0, 0, 0, 0.06);
  --glass-highlight: rgba(255, 255, 255, 0.9);

  --text-primary: #1a1a2e;
  --text-secondary: #5a5a70;
  --text-tertiary: #8a8aa0;
  --text-placeholder: #b0b0c0;

  --color-primary: #5b5fc7;
  --color-primary-hover: #4f46e5;
  --color-primary-glow: rgba(91, 95, 199, 0.2);

  --message-user-bg: linear-gradient(135deg, rgba(91, 95, 199, 0.12), rgba(124, 58, 237, 0.08));
  --message-user-border: rgba(91, 95, 199, 0.2);
  --message-assistant-bg: transparent;

  --input-bg: rgba(248, 249, 252, 0.8);
  --input-border: rgba(0, 0, 0, 0.08);
  --input-focus-border: rgba(91, 95, 199, 0.5);
  --input-focus-glow: 0 0 20px rgba(91, 95, 199, 0.1);

  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.06);
  --shadow-md: 0 8px 24px rgba(0, 0, 0, 0.08);
  --shadow-lg: 0 16px 48px rgba(0, 0, 0, 0.1);
}

/* ===== Utility Classes ===== */

/* Text utilities */
.text-primary { color: var(--text-primary); }
.text-secondary { color: var(--text-secondary); }
.text-tertiary { color: var(--text-tertiary); }
.text-accent { color: var(--color-accent); }
.text-glow {
  color: var(--text-primary);
  text-shadow: 0 0 20px var(--text-glow);
}

/* Background utilities */
.bg-base { background: var(--bg-base); }
.bg-primary { background: var(--bg-primary); }
.bg-secondary { background: var(--bg-secondary); }
.bg-tertiary { background: var(--bg-tertiary); }
.bg-glass {
  background: var(--glass-bg);
  backdrop-filter: blur(var(--blur-md));
  -webkit-backdrop-filter: blur(var(--blur-md));
  border: 1px solid var(--glass-border);
}

/* Border radius utilities */
.rounded-xs { border-radius: var(--radius-xs); }
.rounded-sm { border-radius: var(--radius-sm); }
.rounded-md { border-radius: var(--radius-md); }
.rounded-lg { border-radius: var(--radius-lg); }
.rounded-xl { border-radius: var(--radius-xl); }
.rounded-2xl { border-radius: var(--radius-2xl); }
.rounded-full { border-radius: var(--radius-full); }

/* Shadow utilities */
.shadow-sm { box-shadow: var(--shadow-sm); }
.shadow-md { box-shadow: var(--shadow-md); }
.shadow-lg { box-shadow: var(--shadow-lg); }
.shadow-xl { box-shadow: var(--shadow-xl); }
.shadow-glow-primary { box-shadow: var(--shadow-glow-primary); }
.shadow-glow-accent { box-shadow: var(--shadow-glow-accent); }

/* Transition utilities */
.transition-fast { transition: all var(--transition-fast); }
.transition-base { transition: all var(--transition-base); }
.transition-slow { transition: all var(--transition-slow); }
.transition-spring { transition: all var(--transition-spring); }

/* Blur utilities */
.blur-sm { backdrop-filter: blur(var(--blur-sm)); }
.blur-md { backdrop-filter: blur(var(--blur-md)); }
.blur-lg { backdrop-filter: blur(var(--blur-lg)); }
`, "",{"version":3,"sources":["webpack://./../../../packages/apps/myagent/myagent_ui/src/styles/variables.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF,6BAA6B;;AAG7B;EACE,kDAAkD;;EAElD,6CAA6C;EAC7C,wBAAwB;EACxB,8BAA8B;EAC9B,6CAA6C;EAC7C,6CAA6C;;EAE7C,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,4CAA4C;;EAE5C,4BAA4B;EAC5B,0BAA0B;EAC1B,gCAAgC;;EAEhC,iDAAiD;EACjD,kBAAkB;EAClB,qBAAqB;EACrB,qCAAqC;EACrC,oCAAoC;EACpC,oCAAoC;EACpC,iCAAiC;;EAEjC,6BAA6B;EAC7B,qCAAqC;EACrC,yCAAyC;EACzC,2CAA2C;;EAE3C,qCAAqC;EACrC,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,mBAAmB;EACnB,qCAAqC;;EAErC,4BAA4B;EAC5B,6FAA6F;EAC7F,8CAA8C;EAC9C,wCAAwC;EACxC,mCAAmC;EACnC,6CAA6C;;EAE7C,iBAAiB;EACjB,iCAAiC;EACjC,yCAAyC;EACzC,6CAA6C;EAC7C,qDAAqD;;EAErD,sCAAsC;EACtC,wBAAwB;EACxB,6CAA6C;EAC7C,wBAAwB;EACxB,6CAA6C;EAC7C,sBAAsB;EACtB,4CAA4C;EAC5C,qBAAqB;EACrB,0CAA0C;;EAE1C,4CAA4C;EAC5C,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;;EAEnB,iDAAiD;EACjD,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;;EAErB,0CAA0C;EAC1C,4FAA4F;EAC5F,qFAAqF;;EAErF,+BAA+B;EAC/B,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;;EAEvB,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;;EAE1B,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;;EAE7B,yCAAyC;EACzC,0CAA0C;EAC1C,0CAA0C;EAC1C,4CAA4C;EAC5C,2CAA2C;EAC3C,yDAAyD;EACzD,uDAAuD;EACvD,uDAAuD;;EAEvD,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;;EAEtB,iDAAiD;EACjD,8CAA8C;EAC9C,+CAA+C;EAC/C,2CAA2C;EAC3C,gDAAgD;;EAEhD,8CAA8C;EAC9C,6CAA6C;EAC7C,6CAA6C;EAC7C,6CAA6C;;EAE7C,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;;EAEf,4BAA4B;EAC5B,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,sCAAsC;AACtC;EACE,qBAAqB;EACrB,qCAAqC;EACrC,oCAAoC;EACpC,oCAAoC;;EAEpC,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;;EAExB,6FAA6F;EAC7F,8CAA8C;EAC9C,mCAAmC;;EAEnC,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yCAAyC;EACzC,uCAAuC;EACvC,wCAAwC;EACxC,oCAAoC;;EAEpC,oCAAoC;EACpC,mCAAmC;EACnC,2CAA2C;;EAE3C,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;;EAE3B,wBAAwB;EACxB,8BAA8B;EAC9B,4CAA4C;;EAE5C,6FAA6F;EAC7F,6CAA6C;EAC7C,mCAAmC;;EAEnC,oCAAoC;EACpC,mCAAmC;EACnC,4CAA4C;EAC5C,mDAAmD;;EAEnD,0CAA0C;EAC1C,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA,gCAAgC;;AAEhC,mBAAmB;AACnB,gBAAgB,0BAA0B,EAAE;AAC5C,kBAAkB,4BAA4B,EAAE;AAChD,iBAAiB,2BAA2B,EAAE;AAC9C,eAAe,0BAA0B,EAAE;AAC3C;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA,yBAAyB;AACzB,WAAW,0BAA0B,EAAE;AACvC,cAAc,6BAA6B,EAAE;AAC7C,gBAAgB,+BAA+B,EAAE;AACjD,eAAe,8BAA8B,EAAE;AAC/C;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA,4BAA4B;AAC5B,cAAc,+BAA+B,EAAE;AAC/C,cAAc,+BAA+B,EAAE;AAC/C,cAAc,+BAA+B,EAAE;AAC/C,cAAc,+BAA+B,EAAE;AAC/C,cAAc,+BAA+B,EAAE;AAC/C,eAAe,gCAAgC,EAAE;AACjD,gBAAgB,iCAAiC,EAAE;;AAEnD,qBAAqB;AACrB,aAAa,4BAA4B,EAAE;AAC3C,aAAa,4BAA4B,EAAE;AAC3C,aAAa,4BAA4B,EAAE;AAC3C,aAAa,4BAA4B,EAAE;AAC3C,uBAAuB,sCAAsC,EAAE;AAC/D,sBAAsB,qCAAqC,EAAE;;AAE7D,yBAAyB;AACzB,mBAAmB,sCAAsC,EAAE;AAC3D,mBAAmB,sCAAsC,EAAE;AAC3D,mBAAmB,sCAAsC,EAAE;AAC3D,qBAAqB,wCAAwC,EAAE;;AAE/D,mBAAmB;AACnB,WAAW,qCAAqC,EAAE;AAClD,WAAW,qCAAqC,EAAE;AAClD,WAAW,qCAAqC,EAAE","sourcesContent":["/**\n * MyAgent UI - Ethereal Tech Design System\n *\n * A distinctive design language that blends ethereal aesthetics with modern tech.\n * Features: Glassmorphism, gradient backgrounds, ambient glow effects,\n * refined typography with Geist font family.\n */\n\n/* Import Geist font family */\n@import url('https://fonts.googleapis.com/css2?family=Geist:wght@300;400;500;600;700&display=swap');\n\n:root {\n  /* ===== Color Palette - Ethereal Spectrum ===== */\n\n  /* Primary Gradient - Deep indigo to violet */\n  --color-primary: #6366f1;\n  --color-primary-hover: #818cf8;\n  --color-primary-glow: rgba(99, 102, 241, 0.4);\n  --color-primary-dim: rgba(99, 102, 241, 0.15);\n\n  /* Accent - Ethereal cyan */\n  --color-accent: #22d3ee;\n  --color-accent-hover: #67e8f9;\n  --color-accent-glow: rgba(34, 211, 238, 0.3);\n\n  /* Secondary - Soft violet */\n  --color-secondary: #a78bfa;\n  --color-secondary-hover: #c4b5fd;\n\n  /* Background - Deep space gradient base colors */\n  --bg-base: #0a0a0f;\n  --bg-primary: #0d0d14;\n  --bg-secondary: rgba(20, 20, 30, 0.8);\n  --bg-tertiary: rgba(30, 30, 45, 0.6);\n  --bg-elevated: rgba(25, 25, 40, 0.9);\n  --bg-hover: rgba(40, 40, 60, 0.5);\n\n  /* Glass effect backgrounds */\n  --glass-bg: rgba(255, 255, 255, 0.03);\n  --glass-border: rgba(255, 255, 255, 0.08);\n  --glass-highlight: rgba(255, 255, 255, 0.1);\n\n  /* Text Colors - Ethereal hierarchy */\n  --text-primary: #f0f0f5;\n  --text-secondary: #a0a0b5;\n  --text-tertiary: #6b6b80;\n  --text-placeholder: #4a4a5e;\n  --text-dim: #3a3a4e;\n  --text-glow: rgba(240, 240, 245, 0.8);\n\n  /* Message-specific colors */\n  --message-user-bg: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(139, 92, 246, 0.15));\n  --message-user-border: rgba(99, 102, 241, 0.3);\n  --message-user-text: var(--text-primary);\n  --message-assistant-bg: transparent;\n  --message-assistant-text: var(--text-primary);\n\n  /* Input colors */\n  --input-bg: rgba(20, 20, 30, 0.6);\n  --input-border: rgba(255, 255, 255, 0.06);\n  --input-focus-border: rgba(99, 102, 241, 0.5);\n  --input-focus-glow: 0 0 20px rgba(99, 102, 241, 0.15);\n\n  /* Status Colors - Luminous variants */\n  --color-success: #34d399;\n  --color-success-glow: rgba(52, 211, 153, 0.3);\n  --color-warning: #fbbf24;\n  --color-warning-glow: rgba(251, 191, 36, 0.3);\n  --color-error: #f87171;\n  --color-error-glow: rgba(248, 113, 113, 0.3);\n  --color-info: #60a5fa;\n  --color-info-glow: rgba(96, 165, 250, 0.3);\n\n  /* ===== Spacing - Generous and airy ===== */\n  --spacing-xs: 4px;\n  --spacing-sm: 8px;\n  --spacing-md: 16px;\n  --spacing-lg: 24px;\n  --spacing-xl: 32px;\n  --spacing-2xl: 48px;\n  --spacing-3xl: 64px;\n\n  /* ===== Border Radius - Soft and organic ===== */\n  --radius-xs: 4px;\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 16px;\n  --radius-xl: 24px;\n  --radius-2xl: 32px;\n  --radius-full: 9999px;\n\n  /* ===== Typography - Geist Family ===== */\n  --font-family: 'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;\n  --font-family-mono: 'Geist Mono', 'SF Mono', 'Fira Code', 'JetBrains Mono', monospace;\n\n  /* Font sizes - Refined scale */\n  --font-size-xs: 11px;\n  --font-size-sm: 13px;\n  --font-size-base: 15px;\n  --font-size-lg: 17px;\n  --font-size-xl: 20px;\n  --font-size-2xl: 26px;\n  --font-size-3xl: 34px;\n  --font-size-4xl: 48px;\n\n  /* Font weights */\n  --font-weight-light: 300;\n  --font-weight-normal: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n\n  /* Line heights */\n  --line-height-tight: 1.3;\n  --line-height-normal: 1.6;\n  --line-height-relaxed: 1.8;\n\n  /* Letter spacing */\n  --letter-spacing-tight: -0.02em;\n  --letter-spacing-normal: 0;\n  --letter-spacing-wide: 0.05em;\n  --letter-spacing-wider: 0.1em;\n\n  /* ===== Shadows - Ethereal depth ===== */\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.15);\n  --shadow-md: 0 8px 24px rgba(0, 0, 0, 0.2);\n  --shadow-lg: 0 16px 48px rgba(0, 0, 0, 0.25);\n  --shadow-xl: 0 24px 64px rgba(0, 0, 0, 0.3);\n  --shadow-glow-primary: 0 0 40px var(--color-primary-glow);\n  --shadow-glow-accent: 0 0 40px var(--color-accent-glow);\n  --shadow-inner: inset 0 1px 0 rgba(255, 255, 255, 0.05);\n\n  /* ===== Z-Index Scale ===== */\n  --z-base: 0;\n  --z-dropdown: 100;\n  --z-header: 200;\n  --z-overlay: 900;\n  --z-modal: 1000;\n  --z-tooltip: 1100;\n  --z-notification: 1200;\n\n  /* ===== Transitions - Smooth and natural ===== */\n  --ease-out-expo: cubic-bezier(0.16, 1, 0.3, 1);\n  --ease-out-quart: cubic-bezier(0.25, 1, 0.5, 1);\n  --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n  --ease-spring: cubic-bezier(0.34, 1.56, 0.64, 1);\n\n  --transition-fast: 150ms var(--ease-out-quart);\n  --transition-base: 250ms var(--ease-out-expo);\n  --transition-slow: 400ms var(--ease-out-expo);\n  --transition-spring: 500ms var(--ease-spring);\n\n  /* ===== Blur values ===== */\n  --blur-sm: 8px;\n  --blur-md: 16px;\n  --blur-lg: 32px;\n  --blur-xl: 64px;\n\n  /* ===== Breakpoints ===== */\n  --breakpoint-sm: 640px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 1024px;\n  --breakpoint-xl: 1280px;\n}\n\n/* ===== Theme: Dark (Default) ===== */\n[data-theme=\"dark\"] {\n  --bg-primary: #0d0d14;\n  --bg-secondary: rgba(20, 20, 30, 0.8);\n  --bg-tertiary: rgba(30, 30, 45, 0.6);\n  --bg-elevated: rgba(25, 25, 40, 0.9);\n\n  --text-primary: #f0f0f5;\n  --text-secondary: #a0a0b5;\n  --text-tertiary: #6b6b80;\n\n  --message-user-bg: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(139, 92, 246, 0.15));\n  --message-user-border: rgba(99, 102, 241, 0.3);\n  --message-assistant-bg: transparent;\n\n  --input-bg: rgba(20, 20, 30, 0.6);\n  --input-border: rgba(255, 255, 255, 0.06);\n}\n\n/* ===== Theme: Light ===== */\n[data-theme=\"light\"] {\n  --bg-base: #f8f9fc;\n  --bg-primary: #ffffff;\n  --bg-secondary: rgba(248, 249, 252, 0.95);\n  --bg-tertiary: rgba(240, 241, 246, 0.9);\n  --bg-elevated: rgba(255, 255, 255, 0.98);\n  --bg-hover: rgba(240, 241, 246, 0.8);\n\n  --glass-bg: rgba(255, 255, 255, 0.7);\n  --glass-border: rgba(0, 0, 0, 0.06);\n  --glass-highlight: rgba(255, 255, 255, 0.9);\n\n  --text-primary: #1a1a2e;\n  --text-secondary: #5a5a70;\n  --text-tertiary: #8a8aa0;\n  --text-placeholder: #b0b0c0;\n\n  --color-primary: #5b5fc7;\n  --color-primary-hover: #4f46e5;\n  --color-primary-glow: rgba(91, 95, 199, 0.2);\n\n  --message-user-bg: linear-gradient(135deg, rgba(91, 95, 199, 0.12), rgba(124, 58, 237, 0.08));\n  --message-user-border: rgba(91, 95, 199, 0.2);\n  --message-assistant-bg: transparent;\n\n  --input-bg: rgba(248, 249, 252, 0.8);\n  --input-border: rgba(0, 0, 0, 0.08);\n  --input-focus-border: rgba(91, 95, 199, 0.5);\n  --input-focus-glow: 0 0 20px rgba(91, 95, 199, 0.1);\n\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.06);\n  --shadow-md: 0 8px 24px rgba(0, 0, 0, 0.08);\n  --shadow-lg: 0 16px 48px rgba(0, 0, 0, 0.1);\n}\n\n/* ===== Utility Classes ===== */\n\n/* Text utilities */\n.text-primary { color: var(--text-primary); }\n.text-secondary { color: var(--text-secondary); }\n.text-tertiary { color: var(--text-tertiary); }\n.text-accent { color: var(--color-accent); }\n.text-glow {\n  color: var(--text-primary);\n  text-shadow: 0 0 20px var(--text-glow);\n}\n\n/* Background utilities */\n.bg-base { background: var(--bg-base); }\n.bg-primary { background: var(--bg-primary); }\n.bg-secondary { background: var(--bg-secondary); }\n.bg-tertiary { background: var(--bg-tertiary); }\n.bg-glass {\n  background: var(--glass-bg);\n  backdrop-filter: blur(var(--blur-md));\n  -webkit-backdrop-filter: blur(var(--blur-md));\n  border: 1px solid var(--glass-border);\n}\n\n/* Border radius utilities */\n.rounded-xs { border-radius: var(--radius-xs); }\n.rounded-sm { border-radius: var(--radius-sm); }\n.rounded-md { border-radius: var(--radius-md); }\n.rounded-lg { border-radius: var(--radius-lg); }\n.rounded-xl { border-radius: var(--radius-xl); }\n.rounded-2xl { border-radius: var(--radius-2xl); }\n.rounded-full { border-radius: var(--radius-full); }\n\n/* Shadow utilities */\n.shadow-sm { box-shadow: var(--shadow-sm); }\n.shadow-md { box-shadow: var(--shadow-md); }\n.shadow-lg { box-shadow: var(--shadow-lg); }\n.shadow-xl { box-shadow: var(--shadow-xl); }\n.shadow-glow-primary { box-shadow: var(--shadow-glow-primary); }\n.shadow-glow-accent { box-shadow: var(--shadow-glow-accent); }\n\n/* Transition utilities */\n.transition-fast { transition: all var(--transition-fast); }\n.transition-base { transition: all var(--transition-base); }\n.transition-slow { transition: all var(--transition-slow); }\n.transition-spring { transition: all var(--transition-spring); }\n\n/* Blur utilities */\n.blur-sm { backdrop-filter: blur(var(--blur-sm)); }\n.blur-md { backdrop-filter: blur(var(--blur-md)); }\n.blur-lg { backdrop-filter: blur(var(--blur-lg)); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
